import { render } from "./PersonSectionContact.vue?vue&type=template&id=c4893dc8"
import script from "./PersonSectionContact.vue?vue&type=script&lang=js"
export * from "./PersonSectionContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__